import 'bundles/show/videoTop';
import 'vendor/jquery.isOnScreen';

$(function () {
    const iPad =
        navigator.userAgent.match(/(iPad)/) /* iOS pre 13 */ ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1); /* iPad OS 13 */

    window.CBS.Registry.videopage = true;

    if (!iPad) {
        $('header').css('visibility', 'hidden');
        var timer1;
        var headerVisible = false;
        let win = $(window);

        let scrollPosition = 0;

        function hideMenu() {
            window.clearTimeout(timer1);
            if (document.getElementById('programming-alerts') !== null) {
                $('header').addClass('goUpWithAlert');
            } else {
                $('header').addClass('goUp');
            }
            $('#subnav').addClass('hideSubNav');
            $('.nav-link-container').addClass('hideBackToVideo');
            headerVisible = true;

            $('header').one(
                'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
                function (e) {
                    if (headerVisible) {
                        headerVisible = false;
                        $('header').css('visibility', 'hidden');
                        $('.skin-metadata-manager').css('visibility', 'visible');
                        $('.top-menu-manager').css('visibility', 'visible');
                    }
                }
            );
        }
        function showMenu() {
            $('header').css('visibility', 'visible');
            if (document.getElementById('programming-alerts') !== null) {
                $('header').removeClass('goUpWithAlert');
            } else {
                $('header').removeClass('goUp');
            }
            $('#subnav').removeClass('hideSubNav');
            $('.top-menu-hint').css('visibility', 'hidden');
            $('.top-menu-hint').css('opacity', 0);
            $('.top-menu-hint-bg').css('visibility', 'hidden');
            $('.top-menu-hint-bg').css('opacity', 0);

            $('.skin-metadata-manager').css('visibility', 'hidden');
            $('.top-menu-manager').css('visibility', 'hidden');
        }

        $(window).scroll(function (e) {
            let scrollTop = window.scrollY;
            scrollPosition = scrollTop;

            if (!headerVisible) {
                showMenu();
                //startMouseTimer();
            }

            if (scrollTop > 0) {
                $('.nav-link-container').removeClass('hideBackToVideo');
            } else {
                hideMenu();
                $('.nav-link-container').addClass('hideBackToVideo');
            }
        });
        function startMouseTimer() {
            window.clearTimeout(timer1);
            timer1 = window.setTimeout(hideMenu, 3000);
        }

        $('.backToVideo').on('click', function () {
            window.scrollTo(0, 0);
        });

        $('.menu-link-container').on('mousemove', function () {
            showMenu();
            startMouseTimer();
        });

        $('.header__nav--items').on('mousemove', function () {
            startMouseTimer();
        });

        $('#global-header-container').on('mouseleave', function () {
            if (scrollPosition == 0) {
                hideMenu();
            }
        });

        $('.video__player-area ').on('mousemove', function () {
            clearTimeout($.data(this, 'mouseMoveTimer'));
            $('.top-menu-hint').css('visibility', 'visible');
            $('.top-menu-hint').css('opacity', 1);
            $('.top-menu-hint-bg').css('visibility', 'visible');
            $('.top-menu-hint-bg').css('opacity', 1);

            $.data(
                this,
                'mouseMoveTimer',
                setTimeout(function () {
                    $('.top-menu-hint').css('visibility', 'hidden');
                    $('.top-menu-hint').css('opacity', 0);
                    $('.top-menu-hint-bg').css('visibility', 'hidden');
                    $('.top-menu-hint-bg').css('opacity', 0);
                }, 3000)
            );
        });

        $('.video__player-area').on('mouseout', function () {
            if (scrollPosition == 0) {
                clearTimeout($.data(this, 'mouseMoveTimer'));
                $('.top-menu-hint').css('visibility', 'hidden');
                $('.top-menu-hint').css('opacity', 0);
                $('.top-menu-hint-bg').css('visibility', 'hidden');
                $('.top-menu-hint-bg').css('opacity', 0);
            }
        });
    } else {
        $('body').addClass('body-offset');
        $('#subnav').removeClass('hideSubNav');
        if (document.getElementById('programming-alerts') !== null) {
            $('header').removeClass('goUpWithAlert');
        } else {
            $('header').removeClass('goUp');
        }
    }
});

function resizePlayer() {
    var i = 100;
    do {
        $('.video__player-width-container').css('width', i + '%');
        i--;
    } while ($('.video__metadata').isOnScreen() == false);
}
